import { AxiosInstance } from 'axios'

import { Data } from '../../../domain'
import { withGenericErrorHandling } from '../errors'

interface ProposalPrefillRequest {
  brand: string
  schemeCode: string
  email: string
  data: Data
}

export interface ProposalPrefill {
  prefillResponseId: string
  brand: string
  schemeCode: string
  email?: string
  validationData: Data
  coverStart?: string
  accountData: Data
  quoteData: Data
  profileData: Data
  assetData: Data
}

export interface PrefillClient {
  retrievePrefill: (
    request: Omit<ProposalPrefillRequest, 'brand'>,
  ) => Promise<ProposalPrefill>
}

export const createPrefillClient = (
  getInstance: () => Promise<AxiosInstance>,
  brand: string,
): PrefillClient => ({
  retrievePrefill: (request) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.post<ProposalPrefill>(`/prefill`, {
        ...request,
        brand,
      })
      return response.data
    }),
})
